export class ImportDataService {
    public static canCreateEnquiryFromImportDocHeader(importDocHeaderId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/import/docheader/${importDocHeaderId}/cancreateenquiry`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteImportDocHeader(importDocHeaderId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/import/docheader/${importDocHeaderId}`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}